/*
 * @Author: hehaishen
 * @Date: 2019-06-14 22:03:02
 * @LastEditors: hehaishen
 * @LastEditTime: 2019-10-18 14:41:48
 * @Description: 
 */
const routerArr = [
    {
        path: 'advertisingManagement',
        name: 'advertisingManagement',
        component: (resolve) => require(["page/operation/advertisingManagement"], resolve),
        meta: { show: '1110', title: '资源管理', source: '11b8' }
    },
    {
        path: 'advertisingManagement/details',
        name: 'details',
        component: (resolve) => require(["page/operation/advertisingManagement/details"], resolve),
        meta: { show: '1110', title: '资源管理详情', source: '11b8' }
    },
    {
        path: 'advertisingManagement/addEdit',
        name: 'addEdit',
        component: (resolve) => require(["page/operation/advertisingManagement/addEdit"], resolve),
        meta: { show: '1110', title: '资源管理新增', source: '11b8' }
    },
];

export default routerArr;


// WEBPACK FOOTER //
// ./src/container/pages/operation/_res.js